import { RecruitingInterviewStatics } from '../../../../../../../store/workspace/types';
import MotionWrapper from '../../../../../../../layouts/MotionWrapper';
import styles from './style.module.scss';

/** Recruiting interviews budget five minutes per question. */
const MINUTES_PER_QUESTION = 5;

interface Props {
    examData: RecruitingInterviewStatics | null;
};

export default function RecruitingInterviewSheet({ examData }: Props) {
    const questionCount = examData?.exam.countQuestions ?? 0;

    return (
        <MotionWrapper className={styles.container}>
            <div className={styles.detail}>
                <div className={styles.header}>
                    <div className={styles.header_bottom}>
                        <span className={styles.header_bottom_item}>
                            Question quantities : {examData?.exam.countQuestions}
                        </span>
                        <span className={styles.header_bottom_item}>
                            Interview time : {questionCount * MINUTES_PER_QUESTION}’
                        </span>
                    </div>
                </div>
                <div className={styles.section}>
                    {examData?.exam.questions.map((item, index) => <div
                        key={index}
                        className={styles.section_question}
                    >
                        <span>Question {index + 1}:</span>
                        <span>{item.question}</span>
                    </div>)}
                </div>
            </div>
        </MotionWrapper>
    );
};
